<template>
  <base-container style="height: 100%" :isLoading="loading">
    <el-container style="height: 100%">
      <el-aside width="25%" style="height: 100%">
        <artisan-group style="height: 100%; border: none" title="预约登记">
          <ReserveRegister
            style="height: 100%"
            @after-register="loadOverviews"
          ></ReserveRegister>
        </artisan-group>
      </el-aside>
      <el-main style="height: 100%; padding: 0 5px">
        <artisan-group
          title="病区预约排队概况"
          style="height: 100%; border: none"
        >
          <template #header>
            <el-row type="flex" justify="space-between" align="middle">
              <span>病区预约排队概况</span>
              <el-input
                size="mini"
                style="width: 300px"
                v-model="searchWard"
                placeholder="病区查询"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-row>
          </template>
          <el-card style="height: 100px; margin-bottom: 5px">
            <el-row
              slot="header"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <span>病区汇总</span>
              <el-button
                class="color-danger"
                size="mini"
                type="text"
                icon="el-icon-warning-outline"
                @click="showOtherRecords"
              >
                反馈改期列表
              </el-button>
            </el-row>
            <el-row style="height: 30px; line-height: 30px; text-align: center">
              <el-col class="color-danger" :span="6">
                <span style="font-size: 25px">
                  {{ summary.queueSize }}
                </span>
                <span style="font-size: 17px" v-show="summary.otherCount">-{{ summary.otherCount }}</span>
              </el-col>
              <el-col class="color-warning" :span="6">
                <span style="font-size: 25px"> {{ summary.idleTotal }} </span>
              </el-col>
              <el-col class="color-success" :span="6">
                <span style="font-size: 25px"> {{ summary.verifyTotal }} </span>
              </el-col>
              <el-col class="color-success" :span="6">
                <span
                  style="
                    font-size: 25px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                  @click="viewAudit()"
                >
                  {{ summary.noticeTotal }}
                </span>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-col class="color-danger" style="font-size: 12px" :span="6">
                排队总数
              </el-col>
              <el-col class="color-warning" style="font-size: 12px" :span="6">
                空床总数
              </el-col>
              <el-col class="color-success" style="font-size: 12px" :span="6">
                待审核数
              </el-col>
              <el-col class="color-success" style="font-size: 12px" :span="6">
                通知总数
              </el-col>
            </el-row>
          </el-card>
          <el-row :gutter="10" v-if="searchWards.length">
            <el-col :span="12" v-for="item in searchWards" :key="item.id">
              <el-card
                style="height: 100px; margin-bottom: 5px"
                :style="
                  checkWard?.id == item.id ? 'background-color:#C6E2FF;' : ''
                "
                class="clickable"
                @click.native="wardChange(item)"
              >
                <div
                  slot="header"
                  style="
                    text-overflow: ellipsis;
                    word-break: break-all;
                    white-space: nowrap;
                  "
                >
                  <span>{{ item.name }}</span>
                </div>
                <el-row
                  style="height: 35px; line-height: 35px; text-align: center"
                >
                  <el-col class="color-danger" :span="6">
                    <span style="font-size: 25px">
                      {{ item.queueSize }}
                    </span>
                    <span style="font-size: 17px" v-show="item.otherCount">-{{ item.otherCount }}</span>
                  </el-col>
                  <el-col class="color-warning" :span="6">
                    <span style="font-size: 25px">
                      {{ item.idleTotal }}
                    </span>
                  </el-col>
                  <el-col class="color-success" :span="6">
                    <span style="font-size: 25px">
                      {{ item.verifyCount }}
                    </span>
                  </el-col>
                  <el-col class="color-success" :span="6">
                    <span
                      style="font-size: 25px; text-decoration: underline"
                      @click="viewAudit(item)"
                    >
                      {{ item.noticeCount }}
                    </span>
                  </el-col>
                </el-row>
                <el-row style="text-align: center">
                  <el-col
                    class="color-danger"
                    style="font-size: 12px"
                    :span="6"
                  >
                    排队数
                  </el-col>
                  <el-col
                    class="color-warning"
                    style="font-size: 12px"
                    :span="6"
                  >
                    空床数
                  </el-col>
                  <el-col
                    class="color-success"
                    style="font-size: 12px"
                    :span="6"
                  >
                    审核数
                  </el-col>
                  <el-col
                    class="color-success"
                    style="font-size: 12px"
                    :span="6"
                  >
                    通知数
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <el-empty
            v-else
            description="暂未查询到病区预约排队概况！"
          ></el-empty>
        </artisan-group>
      </el-main>
      <el-aside width="25%" style="height: 100%">
        <artisan-group
          style="height: 100%; border: none"
          :title="'医疗组排队概况--' + (checkWard?.name || '')"
        >
          <el-row
            class="padding-v5"
            type="flex"
            align="middle"
            justify="space-between"
          >
            <div class="padding-h10">医疗组</div>
            <div>
              <span class="bed-count color-danger">排队</span>
              <span class="bed-count color-warning">空闲</span>
              <span class="bed-count color-success">审核</span>
              <span class="bed-count color-success">通知</span>
            </div>
          </el-row>
          <div>
            <el-tree
              :data="members"
              node-key="id"
              default-expand-all
              :props="props"
              :expand-on-click-node="false"
              @node-click="groupQueue"
            >
              <el-row
                style="flex: 1"
                type="flex"
                justify="space-between"
                align="middle"
                slot-scope="{ node, data }"
              >
                <div
                  :class="
                    data.groupId == '0' ? 'color-danger' : 'color-primary'
                  "
                >
                  <b>{{ node.label }}</b>
                  <span class="text-mini"
                    >({{ data.groupId == "0" ? "组长" : "组员" }})</span
                  >
                </div>
                <div>
                  <b class="bed-count color-danger">
                    {{ data.queueSize }}
                  </b>
                  <b class="bed-count color-warning">
                    {{ data.idleTotal }}
                  </b>
                  <b class="bed-count color-success">
                    {{ data.verifyCount }}
                  </b>
                  <b class="bed-count color-success">
                    {{ data.noticeCount }}
                  </b>
                </div>
              </el-row>
            </el-tree>
          </div>
        </artisan-group>
      </el-aside>
    </el-container>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      width="90%"
      height="90%"
      ref="dialog"
      :isLoading="dialog.loading"
    >
      <WardGroupQueue
        v-if="dialog.show"
        :data="leader"
        editable
        @adjust="adjustGroup"
        @sorted="sortGroup"
        @verified="verifyGroup"
      ></WardGroupQueue>
    </artisan-dialog>
    <artisan-dialog
      :title="noticeDialog.title"
      :visible.sync="noticeDialog.show"
      width="85%"
      height="85%"
      ref="noticeDialog"
      :isLoading="noticeDialog.loading"
    >
      <AuditNotice
        :wardId="noticeDialog.wardId"
        :wardName="noticeDialog.wardName"
        v-if="noticeDialog.show"
        @bedBacked="loadOverviews"
      ></AuditNotice>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getWardQueues, getWardGroupQueues } from "@/api/bed/ward";
import ReserveRegister from "./ReserveRegister.vue";
import WardGroupQueue from "./WardGroupQueue.vue";
import AuditNotice from "./AuditNotice.vue";
import { mapMutations } from "vuex";
export default {
  components: { ReserveRegister, WardGroupQueue, AuditNotice },
  data() {
    return {
      loading: false,
      searchWard: "",
      wards: [],
      doctorId: "",
      leader: {
        members: [],
      },
      checkWard: {
        id: "",
        summaries: [],
      },
      queueItem: {},
      dialog: {
        loading: false,
        show: false,
        title: "",
      },
      noticeDialog: {
        wardId: "",
        wardName: "",
        loading: false,
        show: false,
        title: "",
      },
      intervalResult: "",
      props: {
        label: "name",
        children: "members",
      },
    };
  },
  computed: {
    searchWards() {
      return this.wards.filter((c) => c.name.indexOf(this.searchWard) >= 0);
    },
    members() {
      let leaders = this.checkWard?.summaries.filter((c) => c.groupId == "0");
      if (leaders) {
        leaders.forEach((c) => {
          c.members = this.checkWard?.summaries.filter(
            (s) => s.groupId == c.id
          );
        });
      }
      return leaders || [];
    },
    summary() {
      let totalMap = {
        queueSize: 0,
        idleTotal: 0,
        otherCount: 0,
        noticeTotal: 0,
        verifyTotal: 0,
      };
      this.wards.forEach((c) => {
        totalMap.queueSize += c.queueSize;
        totalMap.otherCount += c.otherCount;
        totalMap.idleTotal += c.idleTotal;
        totalMap.noticeTotal += c.noticeCount;
        totalMap.verifyTotal += c.verifyCount;
      });
      return totalMap;
    },
  },
  created() {
    this.loadOverviews();
    this.intervalResult = setInterval(this.loadOverviews, 60000);
  },
  destroyed() {
    clearTimeout(this.intervalResult);
  },
  methods: {
    ...mapMutations(["addTab"]),
    loadOverviews() {
      getWardQueues().then((res) => {
        this.wards = res.data.data;
        if (this.wards.length) {
          if (!this.checkWard?.id) {
            this.wardChange(this.wards[0]);
          } else {
            this.checkWard = this.wards.find((c) => c.id == this.checkWard?.id);
          }
          let msg = "";
          if (this.summary.verifyTotal) {
            msg += `<b class='color-warning'>${this.summary.verifyTotal}个患者</b>入院预约待审核！`;
          }
          if (this.summary.noticeTotal) {
            msg += `<br/><b class='color-danger'>${this.summary.noticeTotal}个患者</b>入院通知未反馈！`;
          }
          if (msg) {
            this.$notify({
              title: "重要提醒",
              dangerouslyUseHTMLString: true,
              message: msg,
              type: "warning",
              duration: 45 * 1000,
              position: "bottom-right",
            });
          }
        }
      });
    },
    wardChange(ward) {
      this.checkWard = ward;
    },
    checkWardGroup(ward) {
      if (ward) {
        this.checkWard = ward;
      }
      this.dialog.title = "入院审核--" + this.checkWard?.name;
      this.dialog.show = true;
    },
    groupQueue(data, node) {
      let doctorId = data.id;
      let name = data.name;
      if (data.groupId != "0") {
        doctorId = node.parent.data.id;
        name = node.parent.data.name;
      }
      this.doctorId = doctorId;
      this.dialog.title =
        "组入院审核--" + name + "医疗--" + this.checkWard?.name;
      this.loadGroupQueue();
      this.dialog.show = true;
    },
    loadGroupQueue() {
      getWardGroupQueues(this.checkWard?.id, this.doctorId).then((res) => {
        let data = res.data.data;
        let leaderIndex = data.findIndex((c) => c.groupId == "0");
        let leader = data[leaderIndex];
        data.splice(leaderIndex, 1);
        leader.members = data;
        this.leader = leader;
      });
    },
    sortGroup() {
      // this.dialog.show = false;
      this.loadOverviews();
    },
    verifyGroup() {
      this.dialog.show = false;
      this.loadGroupQueue();
      this.loadOverviews();
    },
    viewAudit(ward) {
      if (ward) {
        this.noticeDialog.wardId = ward.id;
        this.noticeDialog.wardName = ward.name;
        this.noticeDialog.title = ward.name + "--已审核通知列表";
      } else {
        this.noticeDialog.wardId = "";
        this.noticeDialog.wardName = "";
        this.noticeDialog.title = "已审核通知列表";
      }
      this.noticeDialog.show = true;
    },
    showOtherRecords() {
      this.addTab({
        name: "反馈改期列表",
        icon: "el-icon-warning-outline",
        url: "bed/Record?status=other",
      });
    },
    adjustGroup() {
      this.loadGroupQueue();
      this.loadOverviews();
    },
  },
};
</script>

<style scoped>
.bed-count {
  width: 30px;
  text-align: center;
  display: inline-block;
  margin-right: 10px;
}
</style>
